<template>
    <div>
        <v-dialog v-model="showAiQuestionOption" @click:outside="closeDialog" persistent max-width="900">
            <v-card>
                <Loading />
                <v-toolbar dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{ quizTitle }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="text-center">
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12" sm="12" md="8">
                                <v-textarea v-model="quizInstruction" :label="$t('aditionalInstruction')"
                                    :rules="[rules.counter]" rows="1" maxlength="250" clearable></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="4">
                                <v-text-field v-model="noOfQuestions" :rules="maxNumOfQuestions" type="number"
                                    :label="$t('numberOfQuestions')" clearable></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-select v-model="typeOptionSelect" :label="$t('questionType')"
                                    :items="typeOptionItems" item-text="questionTypeName" item-value="questionTypeId"
                                    :rules="[rules.required]" clearable return-object></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select v-model="lavelOptionSelect" :label="$t('complexityLavel')"
                                    :items="lavelOptionItems" item-text="questionLavelName" item-value="questionLavelId"
                                    :rules="[rules.required]" clearable return-object></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select v-model="categoryOptionSelect" :label="$t('questionCategory')"
                                    :items="categoryOptionItems" item-text="questionCategoryName"
                                    item-value="questionCategoryId" :rules="[rules.required]" clearable
                                    return-object></v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="isExistingQuestions">
                            <v-col cols="12" sm="6" md="4">
                                <v-checkbox v-model="replaceExistingQuestions" :label="$t('replaceExistingQuestions')">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn @click="generateQuestions" class="text-capitalize" outlined>{{
                                $t('generateQuestions') }}</v-btn>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Loading from '../common/Loading.vue'
export default {
    name: 'AiQuestionParameter',
    components: {
        Loading
    },
    data() {
        return {
            quiz: {},
            quizInstruction: '',
            replaceExistingQuestions: false,
            noOfQuestions: 0,
            typeOptionSelect: null,
            typeOptionItems: [],
            lavelOptionSelect: null,
            lavelOptionItems: [],
            categoryOptionSelect: null,
            categoryOptionItems: [],
            rules: {
                required: value => !!value || this.$t('required'),
                counter: value => (value.length <= 250) || this.$t('max250characters'),
                minimumVal: value => (value > 0 && value <= 50) || this.$t('min1andMax50'),
            },
        }
    },
    methods: {
        reset() {
            this.quizInstruction = ''
            this.replaceExistingQuestions = false
            this.noOfQuestions = 0
            this.typeOptionSelect = null
            this.lavelOptionSelect = null
            this.categoryOptionSelect = null
        },
        closeDialog() {
            this.$store.dispatch('dashboard/switchShowAiQuestionParameter', false)
        },
        getTypeOptions() {
            this.$store.dispatch('quiz/fetchTypeOptions')
                .then((response) => {
                    //console.log(response.data)
                    response.data.push({ questionTypeId: 3, questionTypeName: 'True/False' })
                    this.typeOptionItems = response.data
                })
                .catch((err) => {
                    console.log(err)
                    this.$router.push({ name: 'NoInternet' })
                })
        },
        getLavelOptions() {
            this.$store.dispatch('quiz/fetchLavelOptions')
                .then((response) => {
                    this.lavelOptionItems = response.data
                })
                .catch((err) => {
                    console.log(err)
                    this.$router.push({ name: 'NoInternet' })
                })
        },
        getCategoryOptions() {
            this.$store.dispatch('quiz/fetchCategoryOptions')
                .then((response) => {
                    this.categoryOptionItems = response.data
                })
                .catch((err) => {
                    console.log(err)
                    this.$router.push({ name: 'NoInternet' })
                })
        },
        generateQuestions() {
            if (this.$store.getters['dashboard/selectedAi'] == 'Gemini AI') {
                this.generateGeminiAiQuestions()
            } else {
                this.generateOpenAiQuestions()
            }
        },
        generateOpenAiQuestions() {
            if (this.$refs.form.validate()) {
                if (this.$store.getters['question/quiz'].isRunning ?? false) {
                    this.$root.$emit('message_from_parent_long', this.$t('liveInterruptionForRunningAssessment'))
                } else {
                    this.$store.dispatch('dashboard/applyLoading')
                    const objQuiz = {
                        quizId: this.$store.getters['question/quiz'].quizTopicId,
                        quizMarkOptionId: this.$store.getters['question/quiz'].quizMarkOptionId,
                        quizTitle: this.$store.getters['question/quiz'].quizTitle,
                        quizInstruction: this.quizInstruction,
                        isDeletePreviousQuestions: this.replaceExistingQuestions,
                        previousQuestionsCount: this.$store.getters['question/quiz'].questionsCount ?? 0,
                        noOfQuestions: this.noOfQuestions,
                        questionTypeId: this.typeOptionSelect.questionTypeId,
                        questionLavelId: this.lavelOptionSelect.questionLavelId,
                        questionCategoryId: this.categoryOptionSelect.questionCategoryId,
                        addedBy: parseInt(localStorage.getItem('loggedUserId')),
                    }
                    //console.log(objQuiz)
                    this.$store.dispatch('quiz/generateOpenAiQuestions', objQuiz)
                        .then((response) => {
                            this.$store.dispatch('dashboard/cancelLoading')
                            if (response.status == 200) {
                                this.reset()
                                this.$store.dispatch('dashboard/switchShowAiQuestionParameter', false)
                                this.$router.push({ name: 'QuizQuestions' })
                            } else if (response.status == 202) {
                                this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }

            }

        },
        generateGeminiAiQuestions() {
            if (this.$refs.form.validate()) {
                if (this.$store.getters['question/quiz'].isRunning ?? false) {
                    this.$root.$emit('message_from_parent_long', this.$t('liveInterruptionForRunningAssessment'))
                } else {
                    this.$store.dispatch('dashboard/applyLoading')
                    const objQuiz = {
                        quizTopicId: this.$store.getters['question/quiz'].quizTopicId,
                        quizMarkOptionId: this.$store.getters['question/quiz'].quizMarkOptionId,
                        topic: this.$store.getters['question/quiz'].quizTitle,
                        additionalInstruction: this.quizInstruction,
                        isDeletePreviousQuestions: this.replaceExistingQuestions,
                        previousQuestionsCount: this.$store.getters['question/quiz'].questionsCount ?? 0,
                        numOfQuestions: this.noOfQuestions,
                        questionTypeId: this.typeOptionSelect.questionTypeId,
                        questionType: this.typeOptionSelect.questionTypeName,
                        questionLavelId: this.lavelOptionSelect.questionLavelId,
                        questionCategoryId: this.categoryOptionSelect.questionCategoryId,
                        difficulty: this.lavelOptionSelect.questionLavelName,
                        addedBy: parseInt(localStorage.getItem('loggedUserId')),
                    }
                    //console.log(objQuiz)
                    this.$store.dispatch('quiz/generateGeminiAiQuestions', objQuiz)
                        .then((response) => {
                            //console.log(response)
                            this.$store.dispatch('dashboard/cancelLoading')
                            if (response.status == 200) {
                                this.reset()
                                this.$store.dispatch('dashboard/switchShowAiQuestionParameter', false)
                                this.$router.push({ name: 'QuizQuestions' })
                            } else if (response.status == 202) {
                                this.$root.$emit('message_from_parent_long', this.$t(response.data.responseMsg))
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }

            }

        }

    },
    computed: {
        showAiQuestionOption: function () {
            return this.$store.getters['dashboard/showAiQuestionParameter']
        },
        quizTitle: function () {
            return this.$store.getters['question/quiz'].quizTitle
        },
        isExistingQuestions: function () {
            return this.$store.getters['question/quiz'].questionsCount ?? 0 > 0
        },
        maxNumOfQuestions() {
            return [
                v => (v > 0 && v <= this.$store.getters['dashboard/maxNumOfQuestions']) || 'Min 1 and Max ' + this.$store.getters['dashboard/maxNumOfQuestions'],
                v => /^[1-9]\d*$/.test(v) || 'Must be a positive integer',
            ]
        }
    },
    created() {
        this.getCategoryOptions()
        this.getTypeOptions()
        this.getLavelOptions()
    }
}
</script>